import { TIEBREAKER_ROUND } from './constants'

export const getJudgesRound = (judge, withTopRounds = false) => {
  if (!judge) return 'all'
  if (Array.isArray(judge.rounds) && judge.rounds.length === 0) return 'all'
  if (Array.isArray(judge.rounds) && judge.rounds.length === 1) return judge.rounds[0]
  if (Array.isArray(judge.rounds) && judge.rounds.length === 2 && !withTopRounds) {
    return judge.rounds[0]
  }
  if (Array.isArray(judge.rounds) && judge.rounds.length > 1) {
    return !withTopRounds ? 'all' : JSON.stringify(judge.rounds)
  }
  return judge.rounds
}

export const getAllRoundsValue = (roundNames) => {
  if (!roundNames) return 'all'
  return JSON.stringify([...roundNames, TIEBREAKER_ROUND])
}
